import { plainDate } from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { GetSkuSalesForecastOutput } from "./get-sku-sales-forecast";

export const getSkuSalesForecastBatch = {
  name: "getSkuSalesForecastBatch" as const,
  input: z.object({
    skus: z.array(z.string()),
    startDate: plainDate(),
    endDate: plainDate(),
  }),
  output: z.object({
    forecasts: z.array(GetSkuSalesForecastOutput),
  }),
};
